// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { ValidateMilkabilityReportCreate, ValidateMilkabilityReportCreateSchema } from 'api/gen/ValidateMilkabilityReportCreate';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { ValidateMilkabilityReportUpdate, ValidateMilkabilityReportUpdateSchema } from 'api/gen/ValidateMilkabilityReportUpdate';

export const ValidateMilkabilityReportSchema = t.union([ValidateMilkabilityReportCreateSchema, ValidateMilkabilityReportUpdateSchema]);

export type ValidateMilkabilityReport = t.TypeOf<typeof ValidateMilkabilityReportSchema>;
